import React from "react";
import LoadingToRedirect from "./LoadingToRedirect";

import {
    Route,
  } from "react-router-dom";

  import {useSelector} from 'react-redux'

const UserRoute = ({ children, ...rest }) => {
    const { user } = useSelector((state) => ({
        ...state
    }))

    return user && user.token ? (<Route {...rest}></Route>) : (<LoadingToRedirect />)
}


export default UserRoute;
